import React, { useEffect } from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

const TermsOfService = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-brand-dark min-h-screen text-white">
      <SEO 
        title="Terms of Service - Christian Videos"
        description="Review our Terms of Service to understand the rules and regulations for using the Christian Videos platform."
        url="https://christianvideos.in/terms-of-service"
      />
      {/* Back Button */}
      <div className="p-4 sm:p-6 flex items-center gap-4">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 hover:text-gray-300 transition-colors text-sm sm:text-base"
        >
          <FiArrowLeft size={20} className="sm:w-6 sm:h-6" />
          <span>Back</span>
        </button>
      </div>

      {/* Content */}
      <div className="px-4 sm:px-6 md:px-8 lg:pl-20 lg:pr-8 py-8 sm:py-12 max-w-4xl">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2 text-gradient-accent">
          Terms of Service
        </h1>
        <p className="text-gray-400 mb-8">Last updated: November 2025</p>

        <div className="space-y-6 text-gray-300">
          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">1. Acceptance of Terms</h2>
            <p>
              By accessing and using the Christian Videos platform, you accept and agree to be bound by the 
              terms and provision of this agreement. If you do not agree to abide by the above, please do not 
              use this service.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">2. Use License</h2>
            <p>
              Permission is granted to temporarily download one copy of the materials (information or software) 
              on Christian Videos platform for personal, non-commercial transitory viewing only. This is the grant 
              of a license, not a transfer of title, and under this license you may not:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose or for any public display</li>
              <li>Attempt to decompile or reverse engineer any software contained on the platform</li>
              <li>Remove any copyright or other proprietary notations from the materials</li>
              <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">3. Disclaimer</h2>
            <p>
              The materials on the Christian Videos platform are provided on an 'as is' basis. Christian Videos 
              makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties 
              including, without limitation, implied warranties or conditions of merchantability, fitness for a 
              particular purpose, or non-infringement of intellectual property or other violation of rights.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">4. Limitations</h2>
            <p>
              In no event shall Christian Videos or its suppliers be liable for any damages (including, without 
              limitation, damages for loss of data or profit, or due to business interruption) arising out of the 
              use or inability to use the materials on the platform, even if Christian Videos or an authorized 
              representative has been notified orally or in writing of the possibility of such damage.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">5. Accuracy of Materials</h2>
            <p>
              The materials appearing on Christian Videos platform could include technical, typographical, or 
              photographic errors. Christian Videos does not warrant that any of the materials on the platform 
              are accurate, complete, or current. Christian Videos may make changes to the materials contained 
              on the platform at any time without notice.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">6. Links</h2>
            <p>
              Christian Videos has not reviewed all of the sites linked to its platform and is not responsible 
              for the contents of any such linked site. The inclusion of any link does not imply endorsement by 
              Christian Videos of the site. Use of any such linked website is at the user's own risk.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">7. Modifications</h2>
            <p>
              Christian Videos may revise the Terms of Service for the platform at any time without notice. 
              By using this platform, you are agreeing to be bound by the then current version of these Terms of Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">8. Governing Law</h2>
            <p>
              These terms and conditions are governed by and construed in accordance with the laws of the country 
              in which the service is operated, and you irrevocably submit to the exclusive jurisdiction of the 
              courts in that location.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">9. User Conduct</h2>
            <p>You agree not to use the platform to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Post or transmit unlawful or abusive content</li>
              <li>Interfere with the operation of the platform</li>
              <li>Violate any intellectual property rights</li>
              <li>Engage in harassment or threats</li>
              <li>Post spam or unsolicited advertising</li>
              <li>Attempt to gain unauthorized access to the platform</li>
            </ul>
          </section>

          <section className="bg-gray-800 p-6 rounded-lg">
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">10. Contact</h2>
            <p>
              If you have any questions about these Terms of Service, please contact us at 
              support@christianvideos.in or visit https://christianvideos.in/contact-us.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
